import { useI18n } from "../lib/i18n";

/**
 * Feb 2026 · Pre-Login Sprach-Umschalter (5 Sep 2026 · User-Directive).
 *
 * Einheitlicher DE/EN-Switcher fuer alle Auth-Screens (Signup + Login).
 * Absolut positioniert oben rechts im Formular-Panel, damit er auf ALLEN
 * Viewports (Mobile + Desktop) sichtbar ist. Der bestehende Switcher im
 * linken Navy-Panel (nur Desktop) bleibt zur Bewahrung des visuellen
 * Rhythmus erhalten; dieser hier ist die primaere, immer erreichbare
 * Instanz.
 */
export default function AuthLangSwitch({ className = "" }) {
  const { lang, setLang } = useI18n();
  const de = lang === "de";
  return (
    <div
      data-testid="auth-lang-switch"
      className={`text-[11px] tracking-[0.2em] uppercase text-navy-dark/70 select-none ${className}`}
    >
      <button
        type="button"
        data-testid="auth-lang-de"
        onClick={() => setLang("de")}
        className={`transition-colors hover:text-gold ${de ? "text-gold" : ""}`}
        aria-pressed={de}
        aria-label="Deutsch"
      >
        DE
      </button>
      <span className="mx-2 opacity-40">/</span>
      <button
        type="button"
        data-testid="auth-lang-en"
        onClick={() => setLang("en")}
        className={`transition-colors hover:text-gold ${!de ? "text-gold" : ""}`}
        aria-pressed={!de}
        aria-label="English"
      >
        EN
      </button>
    </div>
  );
}
